import { render } from "./EmployeeUnprocessed25Liquidations.vue?vue&type=template&id=397bd917"
import script from "./EmployeeUnprocessed25Liquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeUnprocessed25Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__